export interface AdyenSessionResponse {
  sessionId: string;
  sessionData: string;
  reference: string;
}

export enum AdyenPaymentState {
  INITIATED = "INITIATED",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
}
